import React from "react";
import {
  ResourceContainer,
  ResourceImage,
  ResourceTitle,
  ResourceDescription,
  ResourceImageMask
} from "./MainResourceItem.style";
import Icon from "../../icons";
import { theme } from "../../Theme";

interface Props {
  id: string;
  title: string;
  description?: string;
  image: string;
  onClick: (id: string) => void;
  seen?: boolean;
}

const MainResourceItem: React.FC<Props> = props => {
  const onClick = () => {
    props.onClick(props.id);
  };
  return (
    <ResourceContainer onClick={onClick}>
      <ResourceImage seen={props.seen} image={props.image}>
        {props.seen && <ResourceImageMask />}
        <Icon
          name={props.seen ? "replay" : "video"}
          fill={props.seen ? "#fff" : theme.color.primary}
          width="4em"
          height="4em"
          opacity={props.seen ? 1 : 0.6}
          style={{ zIndex: 2 }}
        />
      </ResourceImage>
      <ResourceTitle>{props.title}</ResourceTitle>
      <ResourceDescription>{props.description}</ResourceDescription>
    </ResourceContainer>
  );
};

export default MainResourceItem;
